import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { scrollToHash } from "./Navbar";

const LINKS = [
  { label: "Servizi", hash: "#funzionalita" },
  { label: "Chi Siamo", hash: "#manifesto" },
  { label: "Preventivi", hash: "#prezzi" },
  { label: "Contatti", hash: "#contatti" },
];

export default function Footer() {
  return (
    <footer data-testid="footer" className="relative overflow-hidden border-t border-[#D9E4F5] bg-white">
      <div className="mx-auto max-w-7xl px-4 pb-10 pt-20 sm:px-8 lg:px-16">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
          className="flex justify-center"
        >
          <img
            src="/logo.png"
            alt="HELPLY SRLS — Togheter We Can"
            data-testid="footer-logo"
            className="h-40 w-40 rounded-full border border-[#D9E4F5] object-cover shadow-[0_20px_60px_rgba(53,101,174,0.2)] sm:h-52 sm:w-52"
          />
        </motion.div>
        <motion.h2
          initial={{ opacity: 0, y: 60 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
          className="pointer-events-none mt-8 select-none text-center font-display text-[18vw] font-black leading-none tracking-tight text-neon lg:text-[11rem]"
          data-testid="footer-brand"
        >
          HELPLY
        </motion.h2>

        <div className="mt-14 flex flex-col items-center justify-between gap-8 border-t border-[#D9E4F5] pt-8 md:flex-row">
          <div className="flex items-center gap-4">
            <span className="font-mono text-xs text-slate-500">
              © 2026 HELPLY SRLS. Tutti i diritti riservati.
            </span>
            <a
              data-testid="footer-social-facebook"
              href="https://www.facebook.com/profile.php?id=61574314433521"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Facebook HELPLY"
              className="transition-transform duration-300 hover:scale-125"
            >
              <img src="/facebook.svg" alt="Facebook" className="h-4 w-4" />
            </a>
            <a
              data-testid="footer-social-instagram"
              href="https://www.instagram.com/helply_srls/"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Instagram HELPLY"
              className="transition-transform duration-300 hover:scale-125"
            >
              <img src="/instagram.svg" alt="Instagram" className="h-4 w-4" />
            </a>
          </div>
          <nav className="flex flex-wrap items-center justify-center gap-6">
            {LINKS.map((l) => (
              <button
                key={l.label}
                onClick={() => scrollToHash(l.hash)}
                data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                className="font-mono text-xs uppercase tracking-[0.2em] text-slate-500 transition-colors duration-300 hover:text-neon"
              >
                {l.label}
              </button>
            ))}
            <Link
              to="/privacy"
              data-testid="footer-link-privacy"
              className="font-mono text-xs uppercase tracking-[0.2em] text-slate-500 transition-colors duration-300 hover:text-neon"
            >
              Privacy
            </Link>
          </nav>
        </div>
      </div>
    </footer>
  );
}
